import { render, staticRenderFns } from "./ProcedureItem.vue?vue&type=template&id=78736c1a&"
import script from "./ProcedureItem.vue?vue&type=script&lang=js&"
export * from "./ProcedureItem.vue?vue&type=script&lang=js&"
import style0 from "./ProcedureItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports